/* jshint esversion: 6 */
import React from 'react';
import Modal from 'app/components/common/Modal.jsx';
import NumberPicker from "react-widgets/NumberPicker";
import { FormattedNumber } from 'react-intl';

class AddTweetModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            add_on_posts_1: 1
        }

        this.dismissModal = this.dismissModal.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

    }

    componentDidMount() {
        document.addEventListener('keyup', this.onKeyUp);

        // if they have no extra posts, let the default go to 1
        if (this.props.currentQuantity > 1) {
            this.setState({
                add_on_posts_1: this.props.currentQuantity
            });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp(e) {

        if (e.key === "Escape") {
            this.dismissModal();
        }

    }

    dismissModal(e) {

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Dismiss Add Tweets Modal'
            });
        }
        this.props.dismissModal();

    }

    render() {
        let modalContent = null,
            constants = this.props.app.config.constants,
            limits = this.props.calculateAddOns([{
                addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
                quantity: this.state.add_on_posts_1
            }]),
            buttonAction = null,
            buttonLabel = "Your current package",
            buttonClass = "add-posts",
            annualDisclaimer = null;

        if (this.state.add_on_posts_1 !== this.props.currentQuantity) {
            buttonLabel = "Update your package";
            buttonAction = this.props.addPosts;
        } else {
            buttonClass += " inactive";
        }

        if (this.props.user.plan.planCode.match("annual")) {
            annualDisclaimer = (
                <div>
                    <p>Extra posts reset monthly on the {moment(this.props.user.plan.nextBilling).format("Do")}.</p>
                    {this.state.add_on_posts_1 !== this.props.currentQuantity ? (
                        <p>You'll be charged a prorated amount for your updated plan.</p>
                    ) : null}
                </div>
            )
        }

        modalContent = (
            <div className="x-posts-modal">
                <div className="close-warning" onClick={this.dismissModal} aria-label='close' role="button">
                    <i className="fa fa-times"></i>
                </div>
                <div className="warning-content">
                    <h3 style={{"fontWeight": 500}}>Post more on X every month</h3>
                    <p>Extra posts are shared between all of your X accounts on dlvr.it and renew with your plan.</p>
                    <div className="x-post-wrapper">
                        <NumberPicker
                            className="x-post-picker"
                            min={0}
                            value={this.state.add_on_posts_1}
                            onChange={(value) => {
                                if (this.props.recordEvent) {
                                    this.props.recordEvent({
                                        pub_id: this.props.user.detail.id,
                                        event_name: 'Change Tweet Quantity',
                                        event_data: {
                                            quantity: value
                                        }
                                    });
                                }
                                this.setState({
                                    add_on_posts_1: value
                                });
                            }}/> x 100 = {limits.addOnPosts} extra posts per month for <FormattedNumber value={limits.addOnPostsPrice} style="currency" currency="USD"/> / {this.props.termLabel}
                    </div>
                </div>
                <div className="buttons">
                    <div className={buttonClass} onClick={() => {
                        if (buttonAction) {
                            buttonAction.apply(this, [this.state.add_on_posts_1])
                        }
                    }} role="button">
                        {buttonLabel}
                    </div>
                </div>
                <div className="annual-details">
                    {annualDisclaimer}
                </div>
            </div>
        )

        return (
            <Modal
                content={modalContent}
                boxClass={"x-posts-box"}
                mainClass={"x-posts-content"} />
        );
    }
}

AddTweetModal.displayName = "AddTweetModal";

export default AddTweetModal;
